import PhotoLibraryContainer from './photo_library_container.js'

export default {
  PhotoLibraryContainer,
}
